import React from 'react';
import { TableViewComponent } from '../../../../ui-components/data-viz-ui/table/TableViewComponent';
import { MetricTableViewUiComponentProps } from './types';

export const MetricTableViewUiComponent = (
  props: MetricTableViewUiComponentProps
) => {
  return <TableViewComponent {...props} />;
};
